import { graphql } from "relay-runtime"

export const deCreateRecommendedMedicationMutation = graphql`
  mutation deCreateRecommendedMedicationMutation($input: De_createRecommendedMedicationInput!, $connections: [ID!]!) {
    deCreateRecommendedMedication: de_createRecommendedMedication(input: $input) {
      de_RecommendedMedication @prependNode(connections: $connections, edgeTypeName: "de_ProgressNoteEdge") {
        medication {
          ...deMedicationFragment @relay(mask: false)
        }
        id
        medicationId
        patientId
        progressNoteId
      }

      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
